import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M14.102 7.623a3.501 3.501 0 00-.902-4.345c-1.407-1.146-3.483-.945-4.767.339l-.438.438-.52-.53c-1.634-1.634-4.481-1.314-5.641.957-.676 1.323-.36 2.943.69 3.993l.026.025h2.105l1.678-1.667L9 9.5l1-1h2.695c.296 0 .445.36.235.57L7.993 14l-4.06-4.066"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.433A5.252 5.252 0 0019.8 4.916c-2.11-1.719-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.315 2.75 6.722c-1.014 1.985-.54 4.414 1.036 5.99l.038.037h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42.307 22.867A10.503 10.503 0 0039.6 9.833C35.38 6.395 29.15 7 25.3 10.85l-1.314 1.314-1.562-1.588c-4.902-4.902-13.442-3.944-16.922 2.87-2.028 3.97-1.08 8.828 2.072 11.978l.076.076h6.316l5.034-5 8 8 3-3h8.084c.89 0 1.336 1.078.706 1.708L23.979 42 11.8 29.801"
  }))
};
export var HeartRate = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});